import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import alertPlugin from './plugins/alert';
import store from './store';
import Vuelidate from 'vuelidate'

// routes
import router from './router'

// Font Awesome components
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Web2Case from './components/Web2CaseComponent.vue'
import '../public/google.png'
import '../public/facebook.png'

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
Vue.use(alertPlugin);

Vue.component('fai', FontAwesomeIcon)
Vue.component('web-2-case', Web2Case)
// library.add(fas)
library.add(fas)

new Vue({
    vuetify,
    store,
    router: router,
    render: h => h(App)
}).$mount('#app')
